import refundPolicy from '../../../../config/refundPolicy.json';
import termsOfService from '../../../../config/termsOfService.json';

export const PREMIUM_PLAN = Object.freeze({
    key: 'animebookmark-tracker-premium',
    name: 'AnimeBookmark Episode Tracker Premium',
    description: 'Unlock every supported tracker while keeping Crunchyroll available on the free plan.',
    plannedBasePrices: Object.freeze({
        month: 'CA$4.99',
        quarter: 'CA$13.99',
        year: 'CA$49.99'
    }),
    premiumProviders: Object.freeze([
        'Netflix',
        'Amazon Prime Video',
        'Disney+',
        'HIDIVE',
        'Tubi'
    ])
});

export const PREMIUM_POLICY_ACCEPTANCE = Object.freeze({
    accepted: true,
    termsVersion: termsOfService.metadata.lastUpdated,
    refundPolicyVersion: refundPolicy.metadata.lastUpdated
});

export const isPremiumSubscriptionPagesEnabled = () => (
    process.env.VUE_APP_STRIPE_PAGES_ENABLED === 'true'
);

export const isPremiumCheckoutEnabled = () => (
    isPremiumSubscriptionPagesEnabled()
    && process.env.VUE_APP_STRIPE_CHECKOUT_ENABLED === 'true'
    && ['sandbox', 'production'].includes(process.env.VUE_APP_STRIPE_ENVIRONMENT)
);
